import { render, staticRenderFns } from "./AddressUpdate.vue?vue&type=template&id=6818c96b"
import script from "./AddressUpdate.vue?vue&type=script&lang=ts"
export * from "./AddressUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports